/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Fancybox } from "@fancyapps/ui";
import Flickity from "flickity";
import lottie from "lottie-web";

const HTML = document.querySelector("html");

gsap.registerPlugin(ScrollTrigger);

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) {
            figure.classList.add("img-is-loaded");
          }
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) {
          figure.classList.add("img-is-loaded");
          figure.dispatchEvent(new Event('media-loaded'))
        }
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** Toggle menu */
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });

      window.addEventListener("click", (e) => {
        if (
          HTML.classList.contains("open-menu") &&
          !e.target.classList.contains("main-header") &&
          !e.target.closest(".main-header")
        ) {
          // e.preventDefault();
          HTML.classList.remove("open-menu");
        }
      });
    }

    /** Move header */
    const header = document.querySelector(".main-header");
    if (header) {
      let prevY = 0;
      window.addEventListener("scroll", () => {
        if( window.scrollY > header.offsetHeight* 0.7) {
          HTML.classList.add("scrollup");
        } else {
          
          HTML.classList.remove("scrollup");
        }

        // if (
        //   window.scrollY < prevY &&
        //   window.scrollY > 0 /* && window.scrollY > header.offsetHeight */
        // ) {
        //   HTML.classList.remove("hide-header");
        //   HTML.classList.add("scrollup");
        // } else if (
        //   window.scrollY > 0 /* && window.scrollY > header.offsetHeight */
        // ) {
        //   HTML.classList.remove("scrollup");
        //   HTML.classList.add("hide-header");
        // } else {
        //   HTML.classList.remove("hide-header", "scrollup");
        // }

        prevY = window.scrollY;
      });
      const sections = document.querySelectorAll("section.text-white, section.text-pink-500");
      const BreakException = {};

      window.addEventListener("scroll", () => {
        if (sections) {
          try {
            sections.forEach((section) => {
              const bound = section.getBoundingClientRect();

              if (bound.y - header.offsetHeight / 2 <= 0 && bound.bottom - header.offsetHeight / 2 > 0) {
                HTML.classList.remove("header-black");
                throw BreakException;
              } else {
                HTML.classList.add("header-black");
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          }
        }
      });

      window.dispatchEvent(new Event("scroll"));
    }

    Fancybox.bind("[data-fancybox]", {
      hideScrollbar: false,
      Hash: false,
      toggleZoom: false,
      height: window.innerHeight * 0.75,
      wheel: false,
      Thumbs: false,
      Toolbar: {
        display: {
          left: [],
          middle: ["prev", "next"],
          right: ["close"],
        },
      },
      Images: {
        zoom: false,
      },
    });

    this.gifAnimation();
    this.hoverGifAnimation();
    this.gridImgs();
    this.scrollEnum();
    this.marqueeTxt();
    this.gallery();
    this.magnetism();
    this.accordion();
    this.hoverCoverVideo();
    this.hoverVideo();
    this.textareaResize();
    this.bodymovin();
    this.pub();
    this.inViewport();
  }

  pub() {

    // Fonction pour envoyer un événement de tracking à Google Analytics
    function trackAdEvent(eventType, adElement) {

      const img = adElement.querySelector('img');
      const alt = img ? ` // Partenaire : ${img.alt}` : '';

      console.log(`Tracking ${eventType} pour: ${adElement.id} ${alt} // event :` , eventType); // Debug

      // Vérifier si GA est bien chargé
      if (typeof gtag === "function") {
          gtag("event", eventType, {
              ad_id: adElement.id,
              event_category: "Ads",
              event_label: `Publicité ${eventType} ${alt} (${adElement.id})`,
              value: 1
          });
      }
    }

    // Observer pour détecter quand la publicité entre dans le viewport
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.dataset.tracked) { 
          trackAdEvent("ad_view", entry.target);
          entry.target.dataset.tracked = "true"; // Éviter le tracking multiple
        }
      });
    }, { threshold: 0.5 }); // Se déclenche quand 50% de la pub est visible

    const elts = document.querySelectorAll('.pub-item');
    if( elts ) {
      elts.forEach((el) => {
        if( el.id == 'menu') {
          function openMenu(e) {
            trackAdEvent("ad_view", el)
            toggle.removeEventListener('click', openMenu);
          }
          const toggle = document.querySelector(".toggle-menu");
          if( toggle ) toggle.addEventListener('click', openMenu);
        } else {
          observer.observe(el); // Observer la visibilité
        }

        const link = el.querySelector('a');
        if( link ) {
          link.addEventListener("click", () => trackAdEvent("ad_click", el)); // Tracker le clic
        }

      })
    }
  }

  scrollEnum() {
    const elts = document.querySelectorAll(".scroll-enum");

    if (elts) {
      // if( window.innerWidth < 1024 ) return false;

      elts.forEach((el) => {
        const gridLeft = el.querySelector(".grid-left");

        if (gridLeft) {
          ScrollTrigger.create({
            trigger: el,
            pin: gridLeft,
            start: "top top",
            end: "bottom bottom",
            scrub: 1,
          });
        }

        // Imgs
        const items = el.querySelectorAll(".words a");
        const imgs = el.querySelectorAll(".imgs-square .img");

        if (items && imgs) {
          items.forEach((item, i) => {
            item.addEventListener("mouseenter", () => {
              if (imgs[i]) gsap.set(imgs[i], { autoAlpha: 1 });
            });
            item.addEventListener("mouseleave", () => {
              if (imgs[i]) gsap.set(imgs[i], { autoAlpha: 0 });
            });
          });
        }
      });
    }
  }

  hoverCoverVideo() {
    const elts = document.querySelectorAll('.cover');
    const _ = this;

    if( elts ) {
      elts.forEach(el => {
        const content = el.querySelector('.content-logo');
        const video = el.querySelector('.video-fs');
        const link = el.querySelector('.video-link');
        // const square = el.querySelector('.square-video');
        const base = el.querySelector('.base');

        if( video && base) {
          let boundLink = base.parentElement.getBoundingClientRect();
          let bound = base.getBoundingClientRect();
          let left = bound.x;
          let top = bound.y + window.scrollY;
          let right = (bound.x + bound.width);
          let bottom = (bound.y + window.scrollY + bound.height);

          function getPosition() {
            boundLink = base.parentElement.getBoundingClientRect();
            bound = base.getBoundingClientRect();
            left = bound.x;
            top = bound.y + window.scrollY;
            right = (bound.x + bound.width);
            bottom = (bound.y + window.scrollY + bound.height);
          }

          function onmousemove  (e) {
            if( _.isTouchscreen()) return;
            
            getPosition();

            const { clientX: mouseX, clientY: mouseY } = e;
            const multiply = 1;
            const size = bound.width * multiply;
          
            // Calcul des coordonnées pour clip-path
            const left = mouseX - size / 2;
            const top = (mouseY - size / 2) + window.scrollY;
            const right = mouseX + size / 2;
            const bottom = (mouseY + size / 2) + window.scrollY;
          
            // Appliquer clip-path à la vidéo
            gsap.to(video, {
              clipPath: `polygon(
                ${left}px ${top}px, 
                ${right}px ${top}px, 
                ${right}px ${bottom}px, 
                ${left}px ${bottom}px
              )`,
              duration: 0.2
            })
            const wLink = boundLink.width * multiply;
            const hLink = boundLink.height * multiply;

            const leftLink = boundLink.x > 0 ? boundLink.x + wLink / 2 : boundLink.x + wLink;
            const topLink = boundLink.y > 0 ? boundLink.y + hLink / 2 : boundLink.y + hLink;

            gsap.to(link, {
              x : `${mouseX - leftLink}px`,
              y : `${mouseY - topLink}px`,
              width : `${wLink}px`,
              height : `${hLink}px`,
              duration: 0.2
            })
          }

          function onmouseleave(e) {
            if( _.isTouchscreen()) return;
            gsap.to(link, {
              x : `0%`,
              y : `0%`,
              width : `${boundLink.width}px`,
              height : `${boundLink.height}px`,
              duration: 0.3
            })
            
            gsap.to(video, {
              clipPath: video.dataset.clipPath,
              duration: 0.3
            })
          }

          function resize() {
            getPosition();
            
            video.dataset.clipPath = `polygon(${left}px ${top}px, ${right}px ${top}px, ${right}px ${bottom}px, ${bound.x}px ${bottom}px)`

            if( HTML.classList.contains('video-fullscreen')) {
              gsap.set(video, {
                clipPath: `polygon(0px 0px, ${window.innerWidth}px 0px, ${window.innerWidth}px ${window.innerHeight}px, 0px ${window.innerHeight}px)`,
              })
            }
            else {
              gsap.set(video, {
                clipPath: video.dataset.clipPath
              })
            }

            gsap.set(link, {
              width : `${boundLink.width}px`,
              height : `${boundLink.height}px`,
            })
          }


          /*** Start intro when video is loaded */
          video.addEventListener('media-loaded', () => {
            gsap.to(content, {
              autoAlpha : 1,
              y: '0',
              delay: 0.1,
              duration: 0.9,
              ease: 'expo.out',
              onComplete : () => {
                function scroll() {
                  getPosition();

                  video.dataset.clipPath = `polygon(${left}px ${top}px, ${right}px ${top}px, ${right}px ${bottom}px, ${bound.x}px ${bottom}px)`
                  gsap.fromTo(video ,
                    {
                      clipPath: `polygon(0px 0px, ${window.innerWidth} 0px, ${window.innerWidth} ${window.innerHeight}, 0px ${window.innerHeight})`
                    },
                    {
                      // clipPath: `polygon(${left}px ${top}px, calc(100% - ${right}px) ${top}px, calc(100% - ${right}px) calc(100% - ${bottom}px), ${bound.x}px calc(100% - ${bottom}px))`,
                      clipPath: video.dataset.clipPath,
                      duration: 0.5,
                      ease: 'circ.inOut',
                      onComplete : () => {
                        gsap.set([link,video], {
                          zIndex : 2
                        })

                        window.addEventListener('resize', resize)
  
                        el.addEventListener('mousemove', onmousemove)
  
                        el.addEventListener('mouseleave', onmouseleave)

                        /** Clique sur la vidéo */
                        function clickZoomVideo(e) {
                          el.removeEventListener('mousemove', onmousemove)
                          el.removeEventListener('mouseleave', onmouseleave)
                          link.removeEventListener('click', clickZoomVideo)

                          HTML.classList.add('video-fullscreen')

                          e.preventDefault();

                          gsap.to(video, {
                            clipPath: `polygon(0px 0px, ${window.innerWidth}px 0px, ${window.innerWidth}px ${window.innerHeight}px, 0px ${window.innerHeight}px)`,
                            duration: 0.5,
                            ease: 'circ.inOut',
                            onComplete : () => {
                              /** Si on scroll ou clique, on dézoom */
                              function scrollOut() {
                                getPosition();
                    
                                video.dataset.clipPath = `polygon(${left}px ${top}px, ${right}px ${top}px, ${right}px ${bottom}px, ${bound.x}px ${bottom}px)`
                    
                                gsap.to(video, {
                                  clipPath: video.dataset.clipPath,
                                  duration: 0.5,
                                  ease: 'circ.inOut',
                                  onComplete: () => {
                                    HTML.classList.remove('video-fullscreen')
                                    el.addEventListener('mousemove', onmousemove)
                                    el.addEventListener('mouseleave', onmouseleave)
                                  }
                                })
                    
                                gsap.set(link, {
                                  x : `0%`,
                                  y : `0%`,
                                  width : `${boundLink.width}px`,
                                  height : `${boundLink.height}px`,
                                })
                              
                                window.removeEventListener('scroll', scrollOut)
                                el.removeEventListener('click', scrollOut)
                                link.addEventListener('click', clickZoomVideo)
                              }

                              window.addEventListener('scroll', scrollOut)
                              el.addEventListener('click', scrollOut)
                            }
                          })
                        }

                        if( window.innerWidth > 992 ) {
                          link.addEventListener('click', clickZoomVideo)
                        }
                      }
                    }
                  )
                  window.removeEventListener('scroll', scroll);
                }

                window.addEventListener('scroll', scroll);
              }
            })
          })
        }
      })
    }
  }

  magnetism() {
    const elts = document.querySelectorAll('[data-magnetism]');

    if( elts ) {
      elts.forEach(el => {

        const magneticForce = parseFloat(el.dataset.magnetism) + el.offsetWidth * 0.5; // Distance à laquelle l'effet est ressenti

        document.addEventListener('mousemove', (e) => {
          if( this.isTouchscreen()) return;
          const mouseX = e.clientX;
          const mouseY = e.clientY;

          const magnetRect = el.getBoundingClientRect();
          const magnetX = magnetRect.left + magnetRect.width / 2;
          const magnetY = magnetRect.top + magnetRect.height / 2;

          // Calcul de la distance entre la souris et l'élément
          const distanceX = mouseX - magnetX;
          const distanceY = mouseY - magnetY;
          const distance = Math.sqrt(distanceX ** 2 + distanceY ** 2);

          if (distance < magneticForce) {
            // Calcul de la force proportionnelle
            const force = (magneticForce - distance) / magneticForce;
            const translateX = distanceX * force;
            const translateY = distanceY * force;

            // Appliquer la translation
            // el.style.transform = `translate(${translateX}px, ${translateY}px)`;
            gsap.to(el, {
              duration: 0.2,
              x : `${translateX}px`,
              y : `${translateY}px`
            })
          } else {
            // Réinitialisation de la position
            gsap.to(el, {
              duration: 0.15,
              y: 0,
              x: 0
            })
          }
        });
      })
    }
  }

  hoverVideo() {
    const elts = document.querySelectorAll('[data-hover-video]');

    if( elts ) {
      elts.forEach(el => {
        const bm = el.querySelector('svg');
        const video = el.querySelector('.video');
        // const parent = video.parentElement;
        // const bounding = el.getBoundingClientRect();
        // const boundingParent = parent.getBoundingClientRect();
        const ratio = 1080/1920;


        const magneticForce = 230; // Distance à laquelle l'effet est ressenti

        document.addEventListener('mousemove', (e) => {
          if( this.isTouchscreen()) return;

          const mouseX = e.clientX;
          const mouseY = e.clientY;

          const magnetRect = video.getBoundingClientRect();
          const magnetX = magnetRect.left + magnetRect.width / 2;
          const magnetY = magnetRect.top + magnetRect.height / 2;

          // Calcul de la distance entre la souris et l'élément
          const distanceX = mouseX - magnetX;
          const distanceY = mouseY - magnetY;
          const distance = Math.sqrt(distanceX ** 2 + distanceY ** 2);

          if (distance < magneticForce) {
            // Calcul de la force proportionnelle
            const force = (magneticForce - distance) / magneticForce;
            const translateX = distanceX * force;
            const translateY = distanceY * force;

            // Appliquer la translation
            video.style.transform = `translate(${translateX}px, ${translateY}px)`;
          } else {
            // Réinitialisation de la position
            gsap.to(video, {
              duration: 0.15,
              y: 0,
              x: 0
            })
            // video.style.transform = `translate(0, 0)`;
          }
        });


        if( video && false) {
          el.addEventListener('mouseover', () => {
            gsap.to(video, {
              width : `${el.offsetWidth}px`,
              height : `${el.offsetWidth * ratio}px`,
              x : bounding.x - boundingParent.x,
              y : bounding.y - boundingParent.y,
              duration: 0.3,
              ease: 'Circ.inOut'
            })

            gsap.to(bm, {
              duration: 0.3,
              autoAlpha: 0,
            })
          })

          el.addEventListener('mouseleave', () => {
            gsap.to(video, {
              width : `${parent.offsetWidth}px`,
              height : `${parent.offsetHeight}px`,
              x : 0,
              y : 0,
              duration: 0.3,
              ease: 'Circ.inOut'
            })
            gsap.to(bm, {
              duration: 0.3,
              autoAlpha: 1,
            })
          })
        }
      })
    }
  }

  gifAnimation() {
    const elts = document.querySelectorAll(".gif-animation");

    if (elts) {
      elts.forEach((el, key) => {
        const delay = 0.07;
        const frames = el.querySelectorAll(".img");

        let currentFrame = 0;

        const tl = gsap
          .timeline({
            repeat: -1,
            repeatDelay: 0,
            delay: key * delay,
            paused: true,
          })
          .add(() => {
            frames.forEach((frame, index) => {
              const img = frame.querySelector("img");
              frame.style.visibility =
                index === currentFrame &&
                (img.classList.contains("loaded") || index == 0)
                  ? "visible"
                  : "hidden";
            });
            currentFrame = (currentFrame + 1) % frames.length; // Passer au frame suivant
          }, 0)
          .to({}, { duration: 0.3 }); // Pause entre les frames

          el.addEventListener('mouseenter', () => {
            tl.pause();
          })
          el.addEventListener('mouseleave', () => {
            tl.play();
          })

          el.addEventListener('inview', () => {
            tl.play();
          })
          el.addEventListener('outview', () => {
            tl.pause();
          })
      });
    }
  }

  hoverGifAnimation() {
    const elts = document.querySelectorAll("[data-hover-gif]");

    if (elts) {
      elts.forEach((el) => {
        const target = el.dataset.hoverGif;
        const cells = el.querySelectorAll(target);

        if (cells) {
          cells.forEach((cell) => {
            cell.dataset.index = 0;
          });

          let lastTime = 0;
          const delay = 0.2;
          el.addEventListener("pointermove", (event) => {
            const now = Date.now();
            if (now - lastTime > 200) {
              // Délai de 100 ms entre chaque coeur

              cells.forEach((cell, i) => {
                const imgs = cell.querySelectorAll(".img");
                const current = Number.parseInt(cell.dataset.index);
                if (imgs) {
                  const next =
                    cell.dataset.index >= imgs.length - 1 ? 0 : current + 1;

                  gsap.set(imgs[current], {
                    autoAlpha: 0,
                  });
                  gsap.set(imgs[next], {
                    autoAlpha: 1,
                  });

                  cell.dataset.index = next;
                }
              });
              lastTime = now;
            }
          });

          el.addEventListener("mouseleave", () => {
            const imgs = el.querySelectorAll(".img");
            if (imgs) {
              gsap.set(imgs, { autoAlpha: 0 });
            }
          });
        }
      });
    }
  }

  gridImgs() {
    const elts = document.querySelectorAll(".grid-imgs");

    if (elts) {
      elts.forEach((el) => {
        return false;

        const cells = el.querySelectorAll(".cell");

        if (cells) {
          cells.forEach((cell) => {
            cell.dataset.index = 0;
          });

          let lastTime = 0;
          // const delay = 0;
          const delay = 0.1;
          el.addEventListener("pointermove", (event) => {
            const now = Date.now();
            if (now - lastTime > 400) {
              // Délai de 100 ms

              cells.forEach((cell, i) => {
                const imgs = cell.querySelectorAll(".img");
                const current = Number.parseInt(cell.dataset.index);
                if (imgs) {
                  const next =
                    cell.dataset.index >= imgs.length - 1 ? 0 : current + 1;

                  setTimeout(() => {
                    gsap.set(imgs[current], {
                      autoAlpha: 0,
                      delay: `${delay * i}s`,
                    });
                    gsap.set(imgs[next], {
                      autoAlpha: 1,
                      delay: `${delay * i}s`,
                    });
                  }, delay * i * 1000);

                  cell.dataset.index = next;
                }
              });
              lastTime = now;
            }
          });
        }
      });
    }
  }

  marqueeTxt() {
    const elts = document.querySelectorAll(".marquee-txt");
    const speed = 0.2;
    if (elts) {
      elts.forEach((el) => {
        const clone = el.innerHTML;
        const firstElement = el.children[0];
        let i = 0;

        el.insertAdjacentHTML("beforeend", clone);
        el.insertAdjacentHTML("beforeend", clone);

        setInterval(function () {
          firstElement.style.marginLeft = `-${i}px`;
          if (i > firstElement.clientWidth) {
            i = 0;
          }
          i += speed;
        }, 0);
      });
    }
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");
    if (elts) {
      elts.forEach((accordion) => {
        const items = accordion.querySelectorAll(".accordion-item");
        const triggers = accordion.querySelectorAll(".accordion-header");
        const contents = accordion.querySelectorAll(".accordion-content");

        if (triggers && items && contents) {
          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();

              items[i].classList.toggle("active");

              const h = items[i].classList.contains("active")
                ? contents[i].children[0].offsetHeight
                : 0;

              gsap.to(contents[i], {
                autoAlpha: items[i].classList.contains("active") ? 1 : 0,
                height: h,
                duration: 0.3,
                ease: "circ.inOut",
              });
            });
          });
        }
      });
    }
  }

  gallery() {
    const elts = document.querySelectorAll(".gallery");

    if (elts) {
      elts.forEach((el) => {
        const bar = el.querySelector(".progress .bar");

        new Flickity(el, {
          pageDots: false,
          cellSelector: ".item",
          freeScroll: true,
          wrapAround: true,
          cellAlign: "center",
          on: {
            scroll() {
              const percent = (this.x + this.slidesWidth) / this.slideableWidth;

              if (bar) {
                gsap.set(bar, { scaleX: 1 - percent });
              }
            },
          },
        });
      });
    }
  }


  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {
          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = lottie.loadAnimation({
                  container: tag,
                  renderer: "svg",
                  loop: true,
                  autoplay: true,
                  path: anim,
                  onComplete: () => {
                    // console.log("coucou");
                  },
                });
                tag.classList.add("loaded");
                tag.lottie = l;

                const figure = tag.closest('figure')
                if( figure ) {
                  figure.classList.add('img-is-loaded')
                }
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            tag.lottie.pause();
          }
        });
      });
    }
  }

  textareaResize() {
    /**
     * Textarea
     */
    // expand height textarea
    function autoExpand(field) {
      // Reset field height
      field.style.height = "inherit";

      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);

      // Calculate the height
      const height =
        Number.parseInt(computed.getPropertyValue("border-top-width"), 10) +
        // parseInt(computed.getPropertyValue('padding-top'), 10) +
        field.scrollHeight +
        // parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        Number.parseInt(computed.getPropertyValue("border-bottom-width"), 10);

      field.style.height = `${height}px`;
    }

    document.addEventListener("input", (event) => {
      if (event.target.tagName.toLowerCase() !== "textarea") return;
      autoExpand(event.target);
    });
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }


  isTouchscreen() {
    return ( 'ontouchstart' in window ) || 
    ( navigator.maxTouchPoints > 0 ) || 
    ( navigator.msMaxTouchPoints > 0 );
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
